import React, { useEffect, useRef, useState } from "react";

// libarry tools and framework
import { useLazyQuery, useMutation } from "@apollo/client";
import { Button, Form, Spinner, ProgressBar } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import _ from "lodash";
import { useToasts } from "react-toast-notifications";

// component
import { COLOR_APP, COLOR_TEXT, S3_URL } from "../../../constants";
import { GET_BANKS } from "../../../graphql/bank/query";
import { imageRender } from "../../../helpers";
import { GET_PRESIGN_URL } from "../../../graphql/presignUrl/query";
import { UPDATE_ORDERGROUP } from "../../../graphql/order/mutation";
import { GET_SETTINGS } from "../../../graphql/setting/query";
import { CREATE_USER_CONFIRM } from "../../../graphql/userConfirm/mutation";
import { GET_USER_CONFIRMS } from "../../../graphql/userConfirm/query";


// icons
import { MdAdd, MdDriveFolderUpload, MdRemoveCircle, MdDelete } from "react-icons/md";
import { FaMinus } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faCopy,
  faImages,
} from "@fortawesome/free-solid-svg-icons";
import UploadManyImages from "../../products/productAdd/UploadManyImages";



const ConfirmClaimBalance = ({
  orderData,
  setLastStep,
  setSecondStep,
  shopSettingData,
  bankData,
  isPaymented,
  status
}) => {
  const { addToast } = useToasts();

  // state Hook
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState({});
  const [file, setFile] = useState();
  const [paySlip, setPaySlip] = useState();
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [bankQr, setBankQr] = useState();
  const [defaultBank, setDefaultBank] = useState();
  const [isQrShop, setIsQrShop] = useState(true)
  const [newFiles, setNewFiles] = useState([])
  const [newPaySlip, setNewPaySlip] = useState([]);
  const inputRef = useRef();
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedNewImages, setSelectedNewImage] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [msgError, setMsgError] = useState(null);

  // graphql client
  const [getPresignUrl, { data: presignUrlData }] = useLazyQuery(GET_PRESIGN_URL);
  const [getUserConfirms, { data: userConfirmDatas }] = useLazyQuery(GET_USER_CONFIRMS);
  const [updateOrderGroup, { loading: updateOrderGroupLoading }] = useMutation(UPDATE_ORDERGROUP);
  const [createUserConfirm] = useMutation(CREATE_USER_CONFIRM);


  // useEffect Hooks
  useEffect(() => {
    if (orderData) {
      console.log({ orderData })
      setCustomerName(
        orderData?.customerName != "" && orderData?.customerName
          ? orderData?.customerName
          : orderData?.cfName ?? ""
      );
      //   setNewFiles(orderData?.paySlips)

      getUserConfirms({
        variables: {
          where: {
            psid: orderData?.userFbId
            // name: orderData?.cfName
          },
          orderBy: "createdAt_DESC"
        },
      });
    }
    // if (orderData?.shop) {
    //   _fetchShopSetting(orderData?.shop?.id);
    //   _fetchBank(orderData?.shop?.id);
    // }
  }, [orderData]);

  useEffect(() => {
    if (userConfirmDatas?.userConfirms?.data) {
      const customerJsonData = localStorage.getItem('CUSTOMER_DATA');
      let customerData = {};
      if (customerJsonData) {
        customerData = JSON.parse(customerJsonData)
      }
      setPhone(customerData?.phone || userConfirmDatas?.userConfirms?.data[0]?.phone);
      setAddress(customerData?.addressCF || userConfirmDatas?.userConfirms?.data[0]?.addressCF)
    }
  }, [userConfirmDatas])

  useEffect(() => {
    if (shopSettingData?.settings?.data) {
      setBankQr(shopSettingData?.settings?.data[0]?.bankQr);
      let _bank = JSON.parse(shopSettingData?.settings?.data[0]?.bank);
      setDefaultBank(_bank);
    }
    if (bankData?.banks) {
      setSelectedBank(bankData?.banks?.data[0]);
      setBanks(bankData?.banks?.data);
    }
  }, [bankData, shopSettingData]);

  useEffect(() => {
    if (presignUrlData?.preSignedUrl?.url) {
      onFileUpload(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);

  // function and logic
  const onFileUpload = async (url) => {
    try {
      if (newFiles && url) {
        const uploadfile = await axios.put(url, newFiles, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
        // console.log("uploadfile: ", uploadfile);
      }
    } catch (error) {
      console.log("ERROR: ", error);
    }
  };

  const onCopy = (bankAccount) => {
    navigator.clipboard.writeText(bankAccount ?? "");
    addToast(`Copy ເລກບັນຊີແລ້ວ`, {
      appearance: "success",
      autoDismiss: true,
    });
  };

  const handleUpload = async (event) => {
    try {
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;

      await getPresignUrl({ variables: { name: filename } });
      // console.log("filename: ", filename)
      setPaySlip(filename);
      setNewPaySlip((prevPaySlips) => [...prevPaySlips, filename]);
    } catch (error) {
      console.log(error);
    }
  };

  // handle update new slip
  const handleNewUploadSlip = async (event) => {
    try {
      const file = event.target.files[0];
      setNewFiles((prevFiles) => [...prevFiles, file]);

      var ext = file.name.split(".").pop();

      let filename = uuidv4() + "." + ext;

      await getPresignUrl({ variables: { name: filename } });
      // setPaySlip(filename);
      setNewPaySlip((prevPaySlips) => [...prevPaySlips, filename]);
    } catch (error) {
      console.log(error);
    }
  };

  //   return data image url
  const ImageThumb = ({ image }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image?.name ?? image}
        style={{
          borderRadius: 3,
          height: "100%",
          width: "100%",
        }}
      />
    );
  };

  const _updateOrderGroup = async () => {
    try {
      if (updateOrderGroupLoading) return;

      // Validation checks
      if (_.isEmpty(phone)) {
        addToast(`ກະລຸນາປ້ອນເບີໂທກ່ອນ`, {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }

      if (_.isEmpty(selectedNewImages)) {
        addToast(`ກະລຸນາອັບໂຫຼດສະຄິບໂອນເງິນກ່ອນ`, {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }

      // Set customer data to local storage
      localStorage.setItem('CUSTOMER_DATA', JSON.stringify({
        name: customerName,
        phone: phone,
        addressCF: address,
      }));

      // Create user confirmation
      await createUserConfirm({
        variables: {
          data: {
            name: customerName,
            phone: phone,
            addressCF: address,
            psid: orderData?.userFbId,
            shop: orderData?.shop?.id,
          },
        },
      }).catch((err) => console.log(err));

      // Prepare data for updating order group
      let _data = {
        customerName: customerName,
        phone: phone,
        addressCf: address,
        logistic: address,
        isPaymented: true,
        paymentType: "DESTINATION",
        payment: "TRANSFER",
        bank: selectedBank?.id,
        status: "WAITINGCONFIRM",
        paySlips: selectedNewImages
      };

      //   if (isPaymented && (status === "PAYMENT_STILL_INCOMPLETE" || status === "IMAGE_NOT_YET_PAID" || status === "CREATED")) {
      //     _data = { ..._data, paySlips: newPaySlip };
      //   } else {
      //     _data = {
      //       ..._data,
      //       paySlip: paySlip,
      //     }
      //   }

      // Update order group
      await updateOrderGroup({
        variables: {
          data: _data,
          where: {
            id: orderData?.id,
          },
        },
      });

      setLastStep(true);
      window.location.reload();
      addToast("ບັນທຶກສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      console.log(error);
    }
  };


  const handleRemoveImage = (index) => {
    setNewFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  // update image 
  const handleClick = () => {
    inputRef.current.click();
  };

  
  const handleImageSelect = async (event) => {
    try {
      const files = event.target.files;
      if (!files) return;

      const newImages = [...selectedImages];
      const newImagesMulti = [...selectedNewImages];

      if (newImages.length + files.length > 9) {
        setMsgError("ເລືອກຮູບພາບເພີ່ມເຕີ່ມໄດ້ສູງສຸດ 9 ຮູບ");
        return;
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file) return;
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        if (!allowedTypes.includes(file?.type)) {
          setMsgError(`ກະລຸນາເລືອກຮູບພາບທີ່ເປັນ ${<br></br>}png, jpg, jpge`);
          return;
        }


        const ext = file.name.split(".").pop();
        const filename = uuidv4() + "." + ext;

        const { data } = await getPresignUrl({
          variables: {
            name: filename,
          },
        });

        await uploadToS3(data.preSignedUrl.url, file);
        newImages.push(URL.createObjectURL(file));
        newImagesMulti.push(filename);
        setSelectedNewImage(newImagesMulti);
        setSelectedImages(newImages);
        setMsgError(null); // Clear the error message on successful upload

      }
    } catch (error) {
      console.log("Error uploading image:", error);
      setMsgError("Error uploading image");
    }
  };

  const uploadToS3 = async (url, file) => {
    try {
      const res = await axios.put(url, file, {
        headers: {
          "Content-Type": "file/*; image/*",
        },
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          setUploadProgress(progress);
        },
      });
      if(res) {
        setUploadProgress(0);
      }
    } catch (error) {
      console.log("Error uploading to S3:", error);
      setMsgError("Error uploading to S3");
    }
  };

  const handleImageDelete = (index) => {
    const newImages = [...selectedImages];
    const newImageS3 = [...selectedNewImages];
    newImages.splice(index, 1);
    newImageS3.splice(index, 1);
    setSelectedImages(newImages);
    setSelectedNewImage(newImageS3);
  };


  return (
    <div
      style={{
        display: "flex",
        width: "95%",
        flexDirection: "column",
        margin: "10px",
        alignItems: "center",
      }}
    >
      {/* <div style={{ display: "flex", whiteSpace: "nowrap" }}>
        <div style={{ fontWeight: "bold", fontSize: 20, margin: 10 }}>
          ຊ່ອງທາງການຊຳລະ
        </div>
      </div> */}
      {/* <div style={{  width: '100%', padding: '20px 5px', margin: '10px 5px', background: '#FFF' }}>
        <img src={imageRender()} style={{ width: "15vw", marginTop: 10, marginRight: 10, height: "auto", borderRadius: 10 }} />
        <div>ບັນຊີທະນາຄານ</div>
      </div> */}
      {banks?.length > 0 && (
        <div style={{ width: "100%" }}>
          <div style={{ fontWeight: "bold", width: "100%", textAlign: "left" }}>
            ເລືອກບັນຊີທະນາຄານ
          </div>
          <Form.Group>
            <Form.Select
              style={{
                fontWeight: "700",
                cursor: "pointer",
              }}
              onChange={(e) => {
                const _newSelectedBank = _.find(banks, { id: e.target.value });
                setSelectedBank(_newSelectedBank);
              }}
            >
              {banks?.length > 0 &&
                banks?.map((bank) => {
                  return (
                    <option key={bank?.id} value={bank?.id}>
                      {bank?.bankName}
                    </option>
                  );
                })}
            </Form.Select>
          </Form.Group>
        </div>
      )}
      <div
        style={{

          width: "100%",
          padding: "20px",
          margin: "10px 5px",
          background: "#FFF",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>ຊື່ບັນຊີ</div>
          <div style={{ fontSize: 18, fontWeight: "bold" }}>
            {selectedBank?.bankUser ?? defaultBank?.bankUser}
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>ເລກບັນຊີ</div>
          <div style={{ fontSize: 18, fontWeight: "bold" }}>
            <FontAwesomeIcon
              icon={faCopy}
              className="mr-2"
              color={COLOR_APP}
              onClick={() => onCopy(selectedBank?.bankAccount)}
            />
            {selectedBank?.bankAccount ?? defaultBank?.bankAccount}
          </div>
        </div>
        {/* <div style={{ padding: 20 }}>
          <Form.Check
            type="switch"
            id="custom-switch"
            label="ສະແດງ qr ຮ້ານ"
            onChange={() => setIsQrShop(!isQrShop)}
          />
        </div> */}

      </div>
      <div
        style={{
          width: "100%",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          padding: 5,
          background: "#FFF",
          border: '1px dashed #777', maxHeight: 400, overflow: 'hidden'
        }}
      >
        <img
          src={imageRender(selectedBank?.image ?? bankQr)}
          style={{ alignSelf: "center", width: "80vw", maxWidth: 300, height: '100%', objectFit: 'cover' }}
        />
      </div>
      <div
        style={{
          fontWeight: "bold",
          width: "100%",
          textAlign: "left",
          fontSize: 20,
        }}
      >
        ບ່ອນອັບໂຫຼດສະຄິບໂອນເງິນ
      </div>


      <div style={{ display: "flex", width: "100%", justifyContent: "start", padding: 5 }}>
        {orderData?.paySlip && <div>
          <img style={{ maxWidth: 130, maxHeight: 230, borderRadius: 5 }} src={S3_URL + orderData?.paySlip} />
        </div>}
        &nbsp;
        <div style={{ display: 'flex', justifyContent: 'center', gap: 5, borderRadius: 5 }}>
          {newFiles.map((item, index) => (
            <div key={index} style={{ maxWidth: 130, minWidth: 130, maxHeight: 230, overflow: 'hidden', border: '1px solid #dddd', borderRadius: 3, position: 'relative' }}>
              <button
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={() => handleRemoveImage(index)}
              >
                <MdRemoveCircle style={{ color: "red", fontSize: 24 }} />
              </button>
              <ImageThumb image={item?.paySlips ?? item} />
            </div>
          ))}
        </div>

        {/* {newFiles?.length < 2 &&
          <label htmlFor="file-upload">
            <div
              style={{
                background: "#fff",
                border: `3px dashed ${COLOR_APP}`,
                borderRadius: 8,
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="file"
                id="file-upload"
                onChange={handleNewUploadSlip}
                hidden
              />
              <div
                style={{
                  display: "flex",
                  height: 140,
                  width: 140,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <MdAdd style={{ color: COLOR_TEXT, fontSize: 50 }} />
              </div>
            </div>
          </label>

        } */}

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', justifyContent: 'center' }}>
          {selectedImages.map((image, index) => (
            <div key={index} style={containerStyle}>
              <div className="w-full">
                <img
                  src={image}
                  alt={`Image ${index}`}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div onClick={() => handleImageDelete(index)} style={deleteIconContainerStyle}>
                <FaMinus />
              </div>
            </div>
          ))}
        </div>

        {selectedImages?.length < 2 && <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <input
            style={{ display: "none" }}
            ref={inputRef}
            type="file"
            onChange={handleImageSelect}
          />
          <Button
            // style={{
            //   background: COLOR_APP,
            //   color: '#ffff',
            // }}
            variant="outline-primary"
            disabled={selectedImages.length >= 9}
            onClick={handleClick}
          >
            <MdAdd style={{ fontSize: 28, fontWeight: 'bold' }} />
          </Button>
        </div>}

      </div>


      {/* {uploadProgress >= 1 && <div className="w-100">
  <ProgressBar striped variant="success"  now={uploadProgress} label={`${uploadProgress}%`} />
  </div>} */}


      <div
        style={{
          fontWeight: "bold",
          width: "100%",
          textAlign: "left",
          fontSize: 20,
          paddingTop: 10
        }}
      >
        ຂໍ້ມູນທີ່ຢູ່ສົ່ງສິນຄ້າ ເພື່ອຈັດສົ່ງ
      </div>
      <div
        style={{

          width: "100%",
          background: "#FFF",
        }}
      >
        <Form.Group className="mb-3 mt-2">
          <Form.Label
            style={{ marginBottom: 2, fontWeight: "bold", color: "#5C5C5C" }}
          >
            ຊື່ລູກຄ້າ
          </Form.Label>
          <Form.Control
            name="customerName"
            type="text"
            placeholder="ຊື່ລູກຄ້າ"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label
            style={{ marginBottom: 2, fontWeight: "bold", color: "#5C5C5C" }}
          >
            ເບີໂທ
            <span style={{ marginLeft: 1, color: "#FF3939" }}>*</span>
          </Form.Label>
          <div style={{ position: "relative" }}>
            <span
              style={{
                position: "absolute",
                left: "0",
                top: ".41em",
                fontSize: 17,
              }}
            >
              020
            </span>
            <Form.Control
              style={{ paddingLeft: "3em" }}
              name="phone"
              type="text"
              placeholder="xx xxx xxx"
              value={phone}
              onChange={(e) => {
                const _phone = e?.target?.value;

                // Check if the input is a number and has at most 8 digits
                if (!/^\d{0,8}$/.test(_phone)) return;

                setPhone(_phone);
              }}
            // onChange={(e) => setPhone(e.target.value)}
            />
          </div>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label
            style={{ marginBottom: 2, fontWeight: "bold", color: "#5C5C5C" }}
          >
            ທີ່ຢູ່ຂົນສົ່ງ ( ພິມຊື່ຂົນສົ່ງ ສາຂາ ໃຫ້ລະອຽດ )
          </Form.Label>
          <Form.Control
            name="address"
            type="text"
            placeholder="ຕົວຢ່າງ: E.g ຮຸ່ງອາລຸນ ສາຂາ ປາກທ້າງ"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </Form.Group>
      </div>
      <div
        style={{
          display: "flex",
          whiteSpace: "nowrap",
          width: "100%",
        }}
      >

        <Button
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: 20,
            border: "none",
            background: COLOR_APP,

            width: "100%",
          }}
          onClick={() => {
            _updateOrderGroup();
          }}
        >
          {" "}
          {updateOrderGroupLoading && (
            <Spinner className="mr-2" size="sm" animation="border" />
          )}
          ຢືນຢັນການຊໍາລະ
        </Button>
      </div>
    </div >
  );
};

export default ConfirmClaimBalance;



const containerStyle = {
  position: 'relative',
  minWidth: '130px',
  maxWidth: '130px',
  minHeight: '230px',
  maxHeight: '230px',
  marginBottom: '16px',
  border: '1px solid #E2E8F0',
  borderRadius: '5px',
  overflow: 'hidden',
  boxShadow: '0 0 8px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.2s',
  cursor: 'pointer'
};

const imageContainerStyle = {
  height: '120px',
  overflow: 'hidden'
};

const imageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'transform 0.3s'
};

const deleteIconContainerStyle = {
  position: 'absolute',
  top: 0,
  right: 0,
  background: 'rgba(255, 255, 255, 0.8)',
  borderRadius: '50%',
  padding: '4px'
};

const deleteIconStyle = {
  cursor: 'pointer',
  color: 'red',
  fontSize: '20px'
};

const deleteButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '-10px',
  width: '30px',
  height: '30px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0',
};
